module.exports = __webpack_public_path__ + "img/sort-down.ed90d13a.svg";